import { useSelector } from 'react-redux';
import { TypographyStatus } from 'src/components/cards/QuestionnaireCard/styles';
import { selectTransactionOverview } from 'src/redux/slices/transaction';
import { getBusinessDaysDiff } from 'src/utils/common';

const TransactionStateLabel = () => {
	const transaction = useSelector(selectTransactionOverview);

	if (!transaction.state || transaction.state === 'LIVE') {
		return <TypographyStatus sx={{ color: '#20BC39', background: '#CDF3D5' }}>Live</TypographyStatus>;
	}

	if (transaction.state === 'SECURED_SALE') {
		const businessDaysDiff = transaction.sellContractCompletionDate
			? getBusinessDaysDiff(new Date(transaction.sellContractCompletionDate), new Date())
			: null;

		return (
			<TypographyStatus sx={{ color: '#20BC39', background: '#CDF3D5' }}>
				Secured Sale
				{businessDaysDiff !== null ? `: ${40 - businessDaysDiff} day${businessDaysDiff === 1 ? '' : 's'}` : ''}
			</TypographyStatus>
		);
	}

	if (transaction.state === 'ARCHIVED') {
		return <TypographyStatus sx={{ color: '#20BC39', background: '#CDF3D5' }}>Completed</TypographyStatus>;
	}

	if (transaction.state === 'STANDBY') {
		return <TypographyStatus sx={{ color: '#697885', background: '#EDEDED' }}>Standby</TypographyStatus>;
	}

	if (transaction.state === 'DEMO') {
		return <TypographyStatus sx={{ color: '#303838', background: '#00fffb' }}>Demo</TypographyStatus>;
	}

	if (transaction.state === 'FALL_THROUGH') {
		return <TypographyStatus sx={{ color: 'white', background: '#303838' }}>Defunct (Fall-through)</TypographyStatus>;
	}

	if (transaction.state === 'WITHDRAWAL') {
		return (
			<TypographyStatus sx={{ color: 'white', background: '#303838' }}>Defunct (Sale withdrawal)</TypographyStatus>
		);
	}

	if (transaction.state === 'ERROR') {
		return <TypographyStatus sx={{ color: 'white', background: '#303838' }}>Defunct (Error)</TypographyStatus>;
	}

	return <TypographyStatus sx={{ color: 'white', background: '#303838' }}>Defunct (Lost)</TypographyStatus>;
};

export default TransactionStateLabel;
